import styled from 'styled-components'

export const Body = styled.div`
	overflow-y: auto;

	padding: 0 16px;

	p:first-child {
		margin-top: 0;
	}
`
